export default function Select(theme) {
	return {
		MuiSelect: {
			styleOverrides: {
				root: {
					margin: 0,
				},
				select: {
					height: '1.563rem'
				}
			}
		}
	}
}
